@for (item of data.items; track item) {
  <ui-button
    type="submit"
    [buttonStyle]="item.theme ?? 'filled'"
    [name]="item.name"
    (clicked)="submitted.emit(item)"
  >
    {{ item.label }}
  </ui-button>
}
